import { render, staticRenderFns } from "./HistoryDetailCuratorLayout.vue?vue&type=template&id=68c2274e&scoped=true"
import script from "./HistoryDetailCuratorLayout.vue?vue&type=script&lang=js"
export * from "./HistoryDetailCuratorLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2274e",
  null
  
)

export default component.exports